module.exports = __webpack_public_path__ + "static/media/cloud-moon-hail.0de2cb74.svg";